import './general/polyfills';
import './general/arcGraph';
import './general/general';
import '../components/_components';
import '../layouts/courses-detail/course-detail';



// WEBPACK FOOTER //
// ./src/layouts/main.js